import PermissionFields from "./fields";
import PermissionForms from "./forms";
import PermissionConst from "./permission-const";
import PermissionHelpers from "./helpers";
import { permissionUseMutation } from "./hooks";

const Permission = {
    Fields: PermissionFields,
    Forms: PermissionForms,
    Const: PermissionConst,
    Helpers: PermissionHelpers,
    Hooks: permissionUseMutation
};

export default Permission;